export const piForm = {
  services_which_you_use: "Select the purpose of opening an account",
  exp_monthly_turnovers_in_gel: "The monthly transaction volume in GEL",
  settlement_countries: "Settlement countries",
  tax_payer: "Do you have a U.S. Green Card?",
  fatca_street_placeholder: "City, state, and ZIP code",
  please_specify_one_or_both: "Check one or both of the checkboxes provided",
  fatca_federal_tax: "Check an appropriate box for Federal Tax Classification:",
  privacy_of_fatca:
    "I hereby express my consent to process my personal information in compliance with and for the purpose of FATCA regulations.",
  usaTaxPayer: "U.S. Taxpayer",
  fatca_TIN: "Enter your TIN number",
  fatca_TIN_description:
    "Enter your taxpayer identification number (TIN) in the appropriate field. To avoid double income taxation at the source of payment, the specified TIN must match the name in the 'Name' field. For individuals, this is your social security number (SSN). For others, this is your employer identification number (EIN)",
  pep_montly_turnovers_title: "Total anticipated monthly account activity",
  pep_estimated_cash_turnover: "Select the source of funds",
  pep_SourceOfCashFunds: "Select the monthly account turnover",
  pep_sourceOfProperty: "Select the origin of your assets",
  pep_informationRegardingAssets: "Select your assets",
  pep_categoryOfPoliticalyExposedPerson:
    "Are you a politically exposed person or related to one?",
  kyc_categoryOfPoliticalyExposedPersonInfo:
    "Are you a Politically Exposed Person or affiliated with one?",
  mailingAddress: "ZIP Code",
  pep_position: "Position",
  fatca_tinnumber_length_validation: "Enter nine characters",
  pi_kyc_table_header: "Description of sources of wealth / funds / assets",
  kyc_inheritance_certificate: "Inheritance certificate (Copy)",
  kyc_will: "Will (Copy)",
  kyc_bankAccountStatement:
    "Bank account statement verifying the receivings from family members",
  kyc_otherOfficialDocument:
    "Other official document verifying the source of funds of family members",
  kyc_confirmationInvestment:
    "Confirmation from the investment or brokerage company",
  kyc_us_taxpayer: "Are you a U.S. taxpayer?",
  kyc_greencard: "Are you a Green Card holder?",
  kyc_idNumber: "Personal Number",
  kyc_infoCounterparties: "Information about business partners ",
  identification_header: "Identification",
  verification_header: "Verification",
  private_information_header: "Personal Information",
  about_services_header: "About Services",

  procredit_bank: "Procredit Bank",
  avatar_desc: "უნდა იყო სრულწლოვანი საქართველო მოქალაქე",
  account_desc: "პირადობის მოწმობა, ბინადრობის მოწმობა ან პასპორტი",
  hour_desc: "დრო 10 წუთი",
  enter_information: "Enter information",
  info_about_opening_account:
    "An account can be opened by a private individual with an identity card, passport of a citizen of Georgia or with a permanent residence card",
  agreement_remote_processing:
    "I agree to remote <button>processing of my data</button>",
  terms_and_agreement: "I accept the <button>terms of the agreement</button>",
  marketing_purpose_consent:
    "I agree to the <button>processing of my data for marketing purposes</button>",
  already_have_account_header:
    "You already have an account with ProCredit Bank",
  already_have_account_info:
    "If you have forgotten your password, recover your credentials or contact the Contact Center at  *2222 ან + 995 322 222 222",
  authorization: "Authorization",
  confirm_with_code: "Confirm with code",
  code_has_been_sent: "A code has been sent",
  one_time_code: "One-time code ",
  resend_code: "Resend code ",
  bog: "Bank of Georgia",
  tbc: "TBC Bank",
  credo: " Credo Bank",
  liberty: "Liberty Bank",
  choose_verification_method: "Choose a verification method",
  another_bank: "Another Bank",
  another_bank_desc:
    "Verify through another bank where you already have an account in just 1 minute",
  choose_bank: "Select a bank",
  with_procredit: "ProCredit Bank",
  with_procredit_desc:
    "Complete biometric verification with ID document in 5 minutes",

  code_sens_for_registered_bank:
    "The code has been sent to the number registered in the {{bank}}",
  i_agree: "I agree",
  remote_data_processing_header: "Conditions of remote data processing",
  terms_and_agreements_header: "Terms of the agreement",
  marketing_consent_header: "Data processing for marketing purposes",
  sending: "Sending",
  tax_residency_question: "Do you have tax residency in another country?",
  select_country: "Select a country",
  enter_tax_code: "Enter your tax code",
  add_country: "Add a country",
};
